import React, { useEffect, useState } from "react";
import WithdrawBG from "../../Asserts/images/withdraw_desktop.svg";
import WithdrawBGMobile from "../../Asserts/images/withdraw_mobile.svg";
import useDeviceType from "../../Utiles/FindDevice";
import { useFormik } from "formik";
import * as Yup from "yup";
import InfoIcon from "../../Asserts/images/info_icon.svg";
import { baseURL } from "../../services/axiosConfig";
import axios from "axios";
import { refreshTokenV2 } from "../../services/api";
import useToastMessage from "../../Utiles/Toaster";
import { Toaster } from "react-hot-toast";
import CryptoJS from "crypto-js";
import { useDispatch } from "react-redux";

const WithdrawAmount = () => {
  const dispatch = useDispatch()
  const [availableBalance, setAvailableBalance] = useState(0);
  const [originalBalance, setOriginalBalance] = useState(0);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [transferType, setTransferType] = useState("IBAN");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [savedAccounts, setSavedAccounts] = useState([]);
  const [withdrawAll, setWithdrawAll] = useState(false);
  const { showSuccessToast, showErrorToast } = useToastMessage();

  var derived_key = process.env.REACT_APP_ENCRYPTION_KEY ? CryptoJS.enc.Base64.parse(
    process.env.REACT_APP_ENCRYPTION_KEY
  ) : null;
  var iv = process.env.REACT_APP_IV ? CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV) : null;

  const deviceType = useDeviceType();

  const decryptAccountDetails = (encryptedData) => {
    if (!derived_key || !iv) return encryptedData;
    const decrypted_initial = CryptoJS.AES.decrypt(encryptedData, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    const decrypted = CryptoJS.AES.decrypt(decrypted_initial, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
  };

  const getBankAccounts = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/accounts/withdrawal/bank-accounts/`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("access_token")
            )}`,
          },
        }
      );

      const decryptedAccounts = response?.data?.data?.accounts?.map(
        (account) => {
          return {
            ...account,
            account_number: decryptAccountDetails(account.account_number),
            account_name: decryptAccountDetails(account.account_name),
          };
        }
      );

      setSavedAccounts(decryptedAccounts || []);
      const balance = response?.data?.data?.available_balance || 0;
      setAvailableBalance(balance);
      setOriginalBalance(balance);
    } catch (error) {
      if (error?.response?.status === 401) {
        await refreshTokenV2(dispatch);
      }
    }
  };

  useEffect(() => {
    if (withdrawAll) {
      setWithdrawAmount(availableBalance.toString());
    } else {
      setWithdrawAmount(0);
    }
  }, [withdrawAll]);

  useEffect(() => {
    getBankAccounts();
  }, []);

  const IBANaccounts =
    savedAccounts?.filter((account) => account.account_type === "IBAN") || [];

  const BBANaccounts =
    savedAccounts?.filter((account) => account.account_type === "BBAN") || [];

  // const bankAccountValidationSchema = Yup.object({
  //   accountNumber: Yup.string()
  //     .required(`${transferType !== 'IBAN' ? "Account number is required" : "IBAN number is required"}`)
  //     .matches(/^[0-9]+$/, "Account number must contain only numbers"),

  //   confirmAccountNumber: Yup.string()
  //     .required(`${transferType !== 'IBAN' ? "Please confirm your account number" : "Please confirm your IBAN number"}`)
  //     .oneOf([Yup.ref("accountNumber")], "Account numbers must match"),

  //   swiftCode: Yup.string().required("SWIFT code is required"),

  //   bankName: Yup.string()
  //     .required("Bank name is required")
  //     .min(2, "Bank name must be at least 2 characters")
  //     .max(100, "Bank name cannot exceed 100 characters"),

  //   accountName: Yup.string()
  //     .required("Account name is required")
  //     .min(2, "Account name must be at least 2 characters")
  //     .max(100, "Account name cannot exceed 100 characters")
  //     .matches(
  //       /^[a-zA-Z\s]+$/,
  //       "Account name must contain only letters and spaces"
  //     ),

  //   address: Yup.string()
  //     .required("Address is required")
  //     .min(4, "Address must be at least 10 characters")
  //     .max(200, "Address cannot exceed 200 characters"),
  // });

  const bankAccountValidationSchema = Yup.object({
    accountNumber: Yup.string()
      .required(
        transferType !== "IBAN"
          ? "Account number is required"
          : "IBAN number is required"
      )
      .matches(/^[0-9]+$/, "Account number must contain only numbers"),

    confirmAccountNumber: Yup.string()
      .required(
        transferType !== "IBAN"
          ? "Please confirm your account number"
          : "Please confirm your IBAN number"
      )
      .oneOf([Yup.ref("accountNumber")], "Account numbers must match"),

    swiftCode: Yup.string().when([], {
      is: () => transferType !== "IBAN",
      then: (schema) => schema.required("SWIFT code is required"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

    bankName: Yup.string().when([], {
      is: () => transferType !== "IBAN",
      then: (schema) =>
        schema
          .required("Bank name is required")
          .min(2, "Bank name must be at least 2 characters")
          .max(100, "Bank name cannot exceed 100 characters"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

    accountName: Yup.string()
      .required("Account name is required")
      .min(2, "Account name must be at least 2 characters")
      .max(100, "Account name cannot exceed 100 characters")
      .matches(
        /^[a-zA-Z\s]+$/,
        "Account name must contain only letters and spaces"
      ),

    address: Yup.string()
      .required("Address is required")
      .min(10, "Address must be at least 10 characters")
      .max(200, "Address cannot exceed 200 characters"),
  });

  const handlePost = async (values) => {
    try {
      if (withdrawAmount === "" || withdrawAmount === null) {
        showErrorToast("Please enter a withdraw amount");
        return;
      }

      if (Number(withdrawAmount) <= 0) {
        showErrorToast("Withdraw amount must be greater than 0");
        return;
      }

      if (Number(withdrawAmount) > availableBalance) {
        showErrorToast("Insufficient balance");
        return;
      }

      let payload;

      const derived_accountNumber = CryptoJS.AES.encrypt(
        values.accountNumber,
        derived_key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
        }
      ).toString();

      const derived_accountName = CryptoJS.AES.encrypt(
        values.accountName,
        derived_key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
        }
      ).toString();

      const derived_swiftCode = values.swiftCode ? CryptoJS.AES.encrypt(
        values.swiftCode,
        derived_key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
        }
      ).toString() : "";

      if (selectedAccount !== "") {
        payload = {
          amount: withdrawAmount,
          bank_account_id: selectedAccount,
        };
      } else {
        const isFormValid = await formik.validateForm();
        if (Object.keys(isFormValid).length > 0) {
          formik.setTouched({
            accountNumber: true,
            confirmAccountNumber: true,
            swiftCode: true,
            bankName: true,
            accountName: true,
            address: true,
          });
          showErrorToast("Please fill all required fields correctly");
          return;
        }

        payload = {
          amount: withdrawAmount,
          account_name: derived_accountName,
          account_number: derived_accountNumber,
          swift_code: derived_swiftCode,
          bank_name: values.bankName,
          bank_address: values.address,
          account_type: transferType,
        };
      }
      const response = await axios.post(
        `${baseURL}/accounts/withdrawal/create/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("access_token")
            )}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        const newBalance = response?.data?.data?.available_balance;
        if (selectedAccount === "") {
          await getBankAccounts();
        }
        setAvailableBalance(newBalance);

        formik.resetForm();
        setWithdrawAmount("");
        setSelectedAccount("");
        setWithdrawAll(false);

        showSuccessToast("Withdrawal request submitted successfully!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error?.response?.status === 401) {
        await refreshTokenV2(dispatch);
      } else {
        showErrorToast(
          error?.response?.data?.message ||
          "An error occurred while processing your request"
        );
      }
    }
  };

  const handleWithdrawAmountChange = (value) => {
    if (/^\d*$/.test(value)) {
      const numeric = Number(value);
      if (numeric <= availableBalance) {
        setWithdrawAmount(value); // Keep as string to maintain input behavior

        if (withdrawAll && numeric !== availableBalance) {
          setWithdrawAll(false);
        }
      }
    }
  };

  const handleAccountSelection = (accountId) => {
    // If the same account is clicked, deselect it
    if (selectedAccount === accountId) {
      setSelectedAccount("");
    } else {
      setSelectedAccount(accountId);
      // Clear form validation errors when a saved account is selected
      formik.resetForm();
      formik.setTouched({});
      formik.setErrors({});
    }
  };

  const formik = useFormik({
    initialValues: {
      accountNumber: "",
      confirmAccountNumber: "",
      swiftCode: "",
      bankName: "",
      accountName: "",
      address: "",
    },
    validationSchema:
      selectedAccount !== "" ? null : bankAccountValidationSchema,
    enableReinitialize: true,
    onSubmit: handlePost,
  });

  // Clear form errors when a saved account is selected
  useEffect(() => {
    if (selectedAccount !== "") {
      formik.setTouched({});
      formik.setErrors({});
    }
  }, [selectedAccount]);

  if (deviceType === "mobile" || deviceType === "tablet") {
    return (
      <div className="min-h-screen">
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              // color: "#1BA56F",
              fontWeight: "700",
              borderRadius: "0px !important",
              border: `1px solid #1BA56F`,
            },
          }}
        />
        <div className="bg-white border border-[#00000033] rounded-lg">
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="h-full w-full">
              <section
                className="-mt-6 md:mt-6 min-h-[280px] md:min-h-[350px] min-w-[250px] flex flex-col items-center md:space-y-2"
                style={{
                  backgroundImage: `url(${WithdrawBGMobile})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <p className="text-[#007FFF] text-lg md:text-3xl font-bold font-archivo mt-20">
                  $ {availableBalance}
                </p>
                <p className="text-white text-sm md:text-xl font-semibold font-archivo">
                  Winning Amount Available
                </p>
              </section>
            </div>

            <div className="-mt-10 md:mt-0">
              <div className="bg-white p-4 lg:p-6 shadow-sm">
                <div className="mb-6">
                  <div className="flex items-center space-x-2">
                    <input
                      type="text"
                      placeholder="Enter withdraw amount"
                      value={withdrawAmount}
                      onChange={(e) => {
                        handleWithdrawAmountChange(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-", "."].includes(e.key) ||
                          e.ctrlKey ||
                          e.metaKey
                        ) {
                          e.preventDefault();
                        }
                      }}
                      className="w-[100%] px-2 py-2 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm lg:text-base"
                    />
                    <div className="">
                      <span className="bg-gray-100 px-2 py-2 rounded-full text-sm text-gray-600">
                        USD
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <label className="mt-2 flex items-center text-[#00000099] text-sm cursor-pointer">
                      <input
                        type="checkbox"
                        className="mr-2"
                        onClick={() => setWithdrawAll(!withdrawAll)}
                        checked={withdrawAll}
                      />
                      Withdraw all
                    </label>
                  </div>
                </div>
                <div className="mb-6">
                  <h3 className="text-gray-800 font-medium mb-3 text-sm lg:text-base">
                    Transfer to
                  </h3>
                  <div className="flex space-x-6">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="transferType"
                        value="IBAN"
                        checked={transferType === "IBAN"}
                        onChange={(e) => setTransferType(e.target.value)}
                        className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                      />
                      <span className="ml-2 text-gray-700 text-sm lg:text-base">
                        IBAN
                      </span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="transferType"
                        value="BBAN"
                        checked={transferType === "BBAN"}
                        onChange={(e) => setTransferType(e.target.value)}
                        className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                      />
                      <span className="ml-2 text-gray-700 text-sm lg:text-base">
                        BBAN
                      </span>
                    </label>
                  </div>
                </div>
                {savedAccounts.length > 0 ? (
                  <div className="mb-6">
                    <h3 className="text-gray-800 font-medium mb-3 text-sm lg:text-base">
                      Saved accounts
                    </h3>
                    <div className="space-y-3 md:grid md:grid-cols-2 md:gap-4 md:space-y-0">
                      {transferType === "IBAN"
                        ? IBANaccounts.map((account, index) => (
                          <div key={account.id} className="relative">
                            <div
                              className={`border-2 ${selectedAccount === account.id
                                ? "border-blue-500"
                                : "border-gray-200"
                                } rounded-lg p-4 cursor-pointer hover:border-blue-300 transition-colors`}
                              onClick={() =>
                                handleAccountSelection(account.id)
                              }
                            >
                              <div className="flex justify-between items-start">
                                <div className="space-y-1 flex-1 min-w-0">
                                  <div className="flex">
                                    <span className="text-xs text-gray-800 w-16 flex-shrink-0">
                                      IBAN
                                    </span>
                                    <span className="text-xs text-gray-800 mr-2 flex-shrink-0">
                                      :
                                    </span>
                                    <span className="text-xs text-gray-600 break-words overflow-hidden truncate">
                                      {account.account_number}
                                    </span>
                                  </div>
                                  <div className="flex">
                                    <span className="text-xs text-gray-800 w-16 flex-shrink-0">
                                      Account Name
                                    </span>
                                    <span className="text-xs text-gray-800 mr-2 flex-shrink-0">
                                      :
                                    </span>
                                    <span className="text-xs text-gray-600 break-words overflow-hidden truncate">
                                      {account.account_name}
                                    </span>
                                  </div>
                                </div>
                                {selectedAccount === account.id && (
                                  <div className="ml-2 flex-shrink-0">
                                    <div className="w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center">
                                      <svg
                                        className="w-3 h-3 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                        : BBANaccounts.map((account, index) => (
                          <div key={account.id} className="relative">
                            <div
                              className={`border-2 ${selectedAccount === account.id
                                ? "border-blue-500"
                                : "border-gray-200"
                                } rounded-lg p-4 cursor-pointer hover:border-blue-300 transition-colors`}
                              onClick={() =>
                                handleAccountSelection(account.id)
                              }
                            >
                              <div className="flex justify-between items-start">
                                <div className="space-y-1 flex-1 min-w-0">
                                  <div className="flex">
                                    <span className="text-xs text-gray-800 w-16 flex-shrink-0">
                                      BBAN
                                    </span>
                                    <span className="text-xs text-gray-800 mr-2 flex-shrink-0">
                                      :
                                    </span>
                                    <span className="text-xs text-gray-600 break-words overflow-hidden truncate">
                                      {account.account_number}
                                    </span>
                                  </div>
                                  <div className="flex">
                                    <span className="text-xs text-gray-800 w-16 flex-shrink-0">
                                      Account Name
                                    </span>
                                    <span className="text-xs text-gray-800 mr-2 flex-shrink-0">
                                      :
                                    </span>
                                    <span className="text-xs text-gray-600 break-words overflow-hidden truncate">
                                      {account.account_name}
                                    </span>
                                  </div>
                                </div>
                                {selectedAccount === account.id && (
                                  <div className="ml-2 flex-shrink-0">
                                    <div className="w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center">
                                      <svg
                                        className="w-3 h-3 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className="p-4 rounded-lg">
                    <p className="font-archivo">No saved accounts found.</p>
                  </div>
                )}

                {/* New Account Details */}
                <form className="mb-6" onSubmit={formik.handleSubmit}>
                  <h3 className="text-gray-800 font-medium mb-4 text-sm lg:text-base">
                    Account details
                  </h3>
                  <div className="space-y-6">
                    <div>
                      <input
                        type="text"
                        name="accountNumber"
                        placeholder="Account Number"
                        value={formik.values.accountNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.accountNumber &&
                          formik.errors.accountNumber
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.accountNumber &&
                          formik.errors.accountNumber && (
                            <p className="text-red-500 text-xs">
                              {formik.errors.accountNumber}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <input
                        type="text"
                        name="confirmAccountNumber"
                        placeholder="Confirm Account Number"
                        value={formik.values.confirmAccountNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.confirmAccountNumber &&
                          formik.errors.confirmAccountNumber
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.confirmAccountNumber &&
                          formik.errors.confirmAccountNumber && (
                            <p className="text-red-500 text-xs">
                              {formik.errors.confirmAccountNumber}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <input
                        type="text"
                        name="swiftCode"
                        placeholder="SWIFT Code"
                        value={formik.values.swiftCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.swiftCode && formik.errors.swiftCode
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.swiftCode &&
                          formik.errors.swiftCode && (
                            <p className="text-red-500 text-xs">
                              {formik.errors.swiftCode}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <input
                        type="text"
                        name="bankName"
                        placeholder="Bank Name"
                        value={formik.values.bankName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.bankName && formik.errors.bankName
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.bankName && formik.errors.bankName && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.bankName}
                          </p>
                        )}
                      </div>
                    </div>

                    <div>
                      <input
                        type="text"
                        name="accountName"
                        placeholder="Account Name"
                        value={formik.values.accountName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.accountName &&
                          formik.errors.accountName
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.accountName &&
                          formik.errors.accountName && (
                            <p className="text-red-500 text-xs">
                              {formik.errors.accountName}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${formik.touched.address && formik.errors.address
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-0.5 mt-1">
                        {formik.touched.address && formik.errors.address && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.address}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </form>

                <div className="p-2 mb-6 rounded-lg">
                  <div className="flex items-center gap-1">
                    <div className="rounded-full mr-1 mt-0.5">
                      <img
                        src={InfoIcon}
                        alt="Info Icon"
                        className="w-12 md:w-6 md:h-6 h-12"
                      />
                    </div>
                    <p
                      className={`${deviceType === "mobile" ? "text-[10px]" : "text-sm"
                        } text-gray-600`}
                    >
                      For transfers outside the UAE, bank charges and taxes may
                      apply as per your country's laws.
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-2">
                  <button
                    type="submit"
                    onClick={formik.handleSubmit}
                    disabled={!formik.isValid || formik.isSubmitting}
                    className={`${formik.isValid && !formik.isSubmitting
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-gray-400 cursor-not-allowed"
                      } w-full text-white px-8 py-3 rounded-lg font-medium transition-colors`}
                  >
                    {formik.isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      formik.resetForm();
                      setWithdrawAmount("");
                      setSelectedAccount("");
                      setWithdrawAll(false);
                    }}
                    className="w-full text-[14px] bg-gray-100 hover:bg-gray-200 text-[#00000066] px-8 py-3 rounded-lg font-medium transition-colors text-sm "
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-h-screen 2xl:h-[1050px] p-4">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <div className="mx-auto bg-white border 2xl:h-[1000px] rounded-lg border-[#00000033]">
        <div className="grid grid-cols-3">
          <section className="bg-[#082642] rounded-l-lg p-8 2xl:h-[1000px] flex items-center justify-center">
            <div
              className="w-full h-full flex flex-col relative items-center justify-center text-center"
              style={{
                backgroundImage: `url(${WithdrawBG})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <p className="text-[#007FFF] text-[36px] font-bold font-archivo mb-2 2xl:text-[54px]">
                $ {availableBalance}
              </p>
              <p className="text-white text-xl 2xl:text-[30px] font-semibold font-archivo mb-44 2xl:mb-[270px]">
                Winning Amount Available
              </p>
            </div>
          </section>

          {/* Right Panel - Form */}
          <div className="lg:col-span-2 2xl:h-[1000px] 2xl:p-6">
            <div className="p-6">
              {/* Amount Input */}
              <div className="mb-6">
                <div className="flex items-center space-x-4">
                  <input
                    type="text"
                    placeholder="Enter Withdraw Amount"
                    value={withdrawAmount}
                    onChange={(e) => {
                      handleWithdrawAmountChange(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (
                        ["e", "E", "+", "-", "."].includes(e.key) ||
                        e.ctrlKey ||
                        e.metaKey
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="w-[30%] px-4 py-3 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <div className="">
                    <span className="bg-gray-100 px-4 py-3 rounded-full text-sm text-gray-600">
                      USD
                    </span>
                  </div>
                </div>
                <div className="flex justify-start">
                  <label className="mt-2 flex items-center text-[#00000099] text-sm cursor-pointer">
                    <input
                      type="checkbox"
                      className="mr-2"
                      onChange={() => setWithdrawAll(!withdrawAll)}
                      checked={withdrawAll}
                    />
                    Withdraw all
                  </label>
                </div>
              </div>

              {/* Transfer Type */}
              <div className="mb-6">
                <h3 className="text-gray-800 font-medium mb-3">Transfer to</h3>
                <div className="flex space-x-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="transferType"
                      value="IBAN"
                      checked={transferType === "IBAN"}
                      onChange={(e) => {
                        formik.resetForm()
                        setTransferType(e.target.value)
                      }}
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">IBAN</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="transferType"
                      value="BBAN"
                      checked={transferType === "BBAN"}
                      onChange={(e) => {
                        formik.resetForm()
                        setTransferType(e.target.value)
                      }}
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                    />
                    <span className="ml-2 text-gray-700">BBAN</span>
                  </label>
                </div>
              </div>

              {/* Saved Accounts */}
              {savedAccounts.length > 0 ? (
                <div className="mb-6">
                  {transferType === "IBAN" && IBANaccounts.length > 0 ? (
                    <h3 className="text-gray-800 font-medium mb-3">
                      Saved accounts
                    </h3>
                  ) : null}
                  {transferType === "BBAN" && BBANaccounts.length > 0 ? (
                    <h3 className="text-gray-800 font-medium mb-3">
                      Saved accounts
                    </h3>
                  ) : null}
                  <div className="flex items-center space-x-4 overflow-x-auto scrollbar-hide">
                    {transferType === "IBAN"
                      ? IBANaccounts?.map((account, index) => (
                        <div key={account.id} className="relative">
                          <div
                            className={`border ${selectedAccount === account.id
                              ? "border-blue-500"
                              : "border-gray-200"
                              } rounded-lg p-4 cursor-pointer hover:border-blue-300 transition-colors`}
                            onClick={() => handleAccountSelection(account.id)}
                          >
                            <div className="flex justify-between items-start">
                              <div className="space-y-1">
                                <div className="flex">
                                  <span className="text-sm text-gray-800 w-32">
                                    IBAN
                                  </span>
                                  <span className="text-sm text-gray-800 mr-2">
                                    :
                                  </span>
                                  <span className="text-sm text-gray-600">
                                    {account.account_number}
                                  </span>
                                </div>
                                <div className="flex">
                                  <span className="text-sm text-gray-800 w-32">
                                    Account Name
                                  </span>
                                  <span className="text-sm text-gray-800 mr-2">
                                    :
                                  </span>
                                  <span className="text-sm text-gray-600">
                                    {account.account_name}
                                  </span>
                                </div>
                              </div>
                              {selectedAccount === account.id && (
                                <div className="ml-2">
                                  <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                                    <svg
                                      className="w-4 h-4 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                      : BBANaccounts?.map((account, index) => (
                        <div key={account.id} className="relative">
                          <div
                            className={`border ${selectedAccount === account.id
                              ? "border-blue-500"
                              : "border-gray-200"
                              } rounded-lg p-4 cursor-pointer hover:border-blue-300 transition-colors`}
                            onClick={() => handleAccountSelection(account.id)}
                          >
                            <div className="flex justify-between items-start">
                              <div className="space-y-1">
                                <div className="flex">
                                  <span className="text-sm text-gray-800 w-32">
                                    BBAN
                                  </span>
                                  <span className="text-sm text-gray-800 mr-2">
                                    :
                                  </span>
                                  <span className="text-sm text-gray-600">
                                    {account.account_number}
                                  </span>
                                </div>
                                <div className="flex">
                                  <span className="text-sm text-gray-800 w-32">
                                    Account Name
                                  </span>
                                  <span className="text-sm text-gray-800 mr-2">
                                    :
                                  </span>
                                  <span className="text-sm text-gray-600">
                                    {account.account_name}
                                  </span>
                                </div>
                              </div>
                              {selectedAccount === account.id && (
                                <div className="ml-2">
                                  <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                                    <svg
                                      className="w-4 h-4 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <div className="p-4 border rounded-lg">
                  <p className="font-archivo text-black">
                    No saved accounts found.
                  </p>
                </div>
              )}

              {/* New Account Details */}
              <form className="mb-6" onSubmit={formik.handleSubmit}>
                <h3 className="text-gray-800 font-medium mb-4">
                  Enter a new account details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <input
                      type="text"
                      name="accountNumber"
                      placeholder={`${transferType !== 'IBAN' ? "Account Number" : "IBAN Number"}`}
                      value={formik.values.accountNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.accountNumber &&
                        formik.errors.accountNumber
                        ? "border-red-500"
                        : "border-gray-200"
                        }`}
                    />
                    <div className="h-1 mt-1">
                      {formik.touched.accountNumber &&
                        formik.errors.accountNumber && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.accountNumber}
                          </p>
                        )}
                    </div>
                  </div>

                  <div>
                    <input
                      type="text"
                      name="confirmAccountNumber"
                      placeholder={`${transferType !== 'IBAN' ? "Confirm Account Number" : "Confirm IBAN Number"}`}
                      value={formik.values.confirmAccountNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.confirmAccountNumber &&
                        formik.errors.confirmAccountNumber
                        ? "border-red-500"
                        : "border-gray-200"
                        }`}
                    />
                    <div className="h-1 mt-1">
                      {formik.touched.confirmAccountNumber &&
                        formik.errors.confirmAccountNumber && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.confirmAccountNumber}
                          </p>
                        )}
                    </div>
                  </div>

                  {
                    transferType !== 'IBAN' && <div>
                      <input
                        type="text"
                        name="swiftCode"
                        placeholder="SWIFT Code"
                        value={formik.values.swiftCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.swiftCode && formik.errors.swiftCode
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-1 mt-1">
                        {formik.touched.swiftCode && formik.errors.swiftCode && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.swiftCode}
                          </p>
                        )}
                      </div>
                    </div>
                  }

                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                  {
                    transferType !== 'IBAN' && <div>
                      <input
                        type="text"
                        name="bankName"
                        placeholder="Bank Name"
                        value={formik.values.bankName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.bankName && formik.errors.bankName
                          ? "border-red-500"
                          : "border-gray-200"
                          }`}
                      />
                      <div className="h-1 mt-1">
                        {formik.touched.bankName && formik.errors.bankName && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.bankName}
                          </p>
                        )}
                      </div>
                    </div>}

                  <div>
                    <input
                      type="text"
                      name="accountName"
                      placeholder="Account Name"
                      value={formik.values.accountName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.accountName && formik.errors.accountName
                        ? "border-red-500"
                        : "border-gray-200"
                        }`}
                    />
                    <div className="h-1 mt-1">
                      {formik.touched.accountName &&
                        formik.errors.accountName && (
                          <p className="text-red-500 text-xs">
                            {formik.errors.accountName}
                          </p>
                        )}
                    </div>
                  </div>

                  <div>
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full px-4 py-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${formik.touched.address && formik.errors.address
                        ? "border-red-500"
                        : "border-gray-200"
                        }`}
                    />
                    <div className="h-1 mt-1">
                      {formik.touched.address && formik.errors.address && (
                        <p className="text-red-500 text-xs">
                          {formik.errors.address}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </form>

              {/* Info Banner */}
              <div className=" p-4 mb-6">
                <div className="flex items-center space-x-1">
                  <div className="rounded-full p-1 mr-1 mt-0.5">
                    <img src={InfoIcon} alt="Info Icon" className="w-4 h-4" />
                  </div>
                  <p className="text-sm text-[#00000099]">
                    For transfers outside the UAE, bank charges and taxes may
                    apply as per your country's laws.
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-4">
                <button
                  type="submit"
                  onClick={formik.handleSubmit}
                  disabled={!formik.isValid || formik.isSubmitting}
                  className={`${formik.isValid && !formik.isSubmitting
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
                    } text-white px-8 py-3 rounded-lg font-medium transition-colors`}
                >
                  {formik.isSubmitting ? "Submitting..." : "Submit"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                    setWithdrawAmount("");
                    setSelectedAccount("");
                    setWithdrawAll(false);
                  }}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-8 py-3 rounded-lg font-medium transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawAmount;
